import { render, staticRenderFns } from "./UserInfoSimple.vue?vue&type=template&id=5446b516&"
import script from "./UserInfoSimple.vue?vue&type=script&lang=js&"
export * from "./UserInfoSimple.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoSimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports